/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramTransactionsUserControllerGetTopUpVariantsQueryResponse,
  TelegramTransactionsUserControllerGetTopUpVariants401,
} from '../types/TelegramTransactionsUserControllerGetTopUpVariants.ts';

function getTelegramTransactionsUserGetTopUpVariantsUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/transactions/top-up-variants` as const };
  return res;
}

/**
 * {@link /api/user/telegram/transactions/top-up-variants}
 */
export async function telegramTransactionsUserGetTopUpVariants(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramTransactionsUserControllerGetTopUpVariantsQueryResponse,
    ResponseErrorConfig<TelegramTransactionsUserControllerGetTopUpVariants401>,
    unknown
  >({ method: 'GET', url: getTelegramTransactionsUserGetTopUpVariantsUrl().url.toString(), ...requestConfig });
  return res.data;
}
